import { Component, ElementRef, ViewEncapsulation, input, viewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { ApCheckboxComponent } from '@ap/checkbox';

@Component({
    selector: 'ap-checkbox-card',
    templateUrl: './checkbox-card.component.html',
    styleUrls: ['./checkbox-card.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApCheckboxComponent, ReactiveFormsModule]
})
export class ApCheckboxCardComponent {
    private readonly checkbox = viewChild(ApCheckboxComponent, { read: ElementRef });

    /**
     * FormControl to bind to
     */
    public readonly control = input<FormControl<boolean>>(new FormControl(false));

    /**
     * Label of checkbox to show behind checkbox
     */
    public readonly checkboxLabel = input<string>(undefined);

    /**
     * Unique id of field that can be used to map aria fields
     */
    protected uniqueId = `checkbox-card-${Math.round(Math.random() * 10000000)}`;

    /**
     * Toggle control value on click
     */
    public selectCard(): void {
        this.control().setValue(!this.control().value);
        this.checkbox().nativeElement.querySelector('input').focus();
    }

    /**
     * Stop propagation from checkbox because it already sets the correct checkbox state
     * Stopping propagation prevents the select card function to be called
     */
    public stopPropagation(event: Event): void {
        event.stopPropagation();
    }
}
